(ns com.theplantscape.plant-web.api.site
  (:require
   [com.theplantscape.plant-web.draw.api :refer [make-request-async]]
   [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]))

(defn api-fetch-site-stats []
  (make-request-async
    {:method :get
     :uri (api-url-build "/api/v2/stats/metrics")
     ;:headers {:authorization (-> @site-state :auth :access_token)}
     :params {}}))
